<template>
  <div class="rs-page">
    <div class="rs-tabs-wrap">
      <q-tabs
        v-model="activeTab"
        dense
        no-caps
        active-color="teal-7"
        indicator-color="teal-7"
        align="left"
        class="rs-tabs"
      >
        <q-tab name="supply" label="Потребности" />
        <q-tab
          name="requests"
          label="Созданные заявки"
          class="rs-tab-created-requests"
        />
        <q-tab name="supplier" label="Заявки поставщикам" />
      </q-tabs>
    </div>

    <q-tab-panels v-model="activeTab" animated class="rs-tab-panels">
    <q-tab-panel name="supply" class="q-pa-none">
    <div class="rs-toolbar">
      <div class="rs-toolbar__actions">
        <q-btn-group v-if="filteredProjectSections.some(s => !s.loading && s.dateGroups.length > 0)" flat class="rs-expand-btns">
          <q-btn flat dense no-caps icon="unfold_more" size="sm" @click="toggleAllProjects(true)" title="Развернуть все проекты" />
          <q-btn flat dense no-caps icon="unfold_less" size="sm" @click="toggleAllProjects(false)" title="Свернуть все проекты" />
        </q-btn-group>
        <transition name="fade">
          <div v-if="selectedCount" class="rs-sel-group">
            <q-chip dense color="teal-1" text-color="teal-9" icon="check_circle" size="sm">
              {{ selectedCount }} выбр.
            </q-chip>
            <q-btn
              unelevated no-caps size="sm"
              color="teal-7"
              label="Выбор поставщика"
              @click="openSupplierModal"
            />
          </div>
        </transition>
        <q-space />
        <q-select
          v-model="materialFilter"
          :options="filteredMaterialOptions"
          option-label="material_name"
          option-value="material_id"
          label="Материал"
          outlined
          dense
          clearable
          use-input
          input-debounce="200"
          @filter="filterMaterialOptions"
          @update:model-value="onMaterialFilterChange"
          class="rs-material-filter"
        >
          <template #prepend><q-icon name="filter_list" size="xs" color="grey-6" /></template>
          <template #no-option>
            <q-item><q-item-section class="text-grey">Нет результатов</q-item-section></q-item>
          </template>
        </q-select>
        <q-btn-toggle
          v-model="groupBy"
          no-caps dense unelevated
          toggle-color="teal-7"
          color="white"
          text-color="grey-8"
          :options="[
            { value: 'all', label: 'Материалы' },
            { value: 'week', label: 'Недели' },
            { value: 'month', label: 'Месяцы' },
          ]"
          class="rs-group-toggle"
          @update:model-value="onGroupByChange"
        />
      </div>
    </div>

    <div v-if="allProjectsLoading" class="rs-loader">
      <q-spinner-dots color="teal-7" size="48px" />
      <div class="rs-loader__text">Загрузка данных...</div>
    </div>

    <template v-else>
      <div v-if="filteredProjectSections.some(s => s.loading || s.dateGroups.length > 0)" class="rs-content">

        <div v-for="(section, pi) in filteredProjectSections" :key="section.project.sbs_project_id" class="rs-project-section">
          <!-- Заголовок проекта -->
          <div class="rs-project-header" @click="!section.loading && toggleProject(section.project.sbs_project_id)">
            <q-icon
              v-if="!section.loading"
              :name="collapsedProjects[section.project.sbs_project_id] ? 'keyboard_arrow_right' : 'keyboard_arrow_down'"
              size="20px"
              color="teal-8"
              class="rs-project-header__arrow"
            />
            <q-spinner-dots v-else color="teal-6" size="16px" />
            <q-checkbox
              v-if="!section.loading"
              :model-value="isProjectAllSelected(pi)"
              :indeterminate="isProjectSomeSelected(pi) && !isProjectAllSelected(pi)"
              @update:model-value="(val) => toggleProjectAll(pi, val)"
              @click.stop
              dense
              color="teal-7"
            />
            <q-icon name="folder_open" size="18px" color="teal-7" class="rs-project-header__icon" />
            <span class="rs-project-header__name">{{ section.project.sbs_project_name }}</span>
            <q-badge v-if="!section.loading" rounded color="teal-1" text-color="teal-9" class="q-ml-sm">
              {{ section.dateGroups.reduce((s, g) => s + g.materials.length, 0) }} мат.
            </q-badge>
          </div>

          <!-- Контент секции (с анимацией) -->
          <transition name="rs-slide">
          <div v-if="!section.loading && !collapsedProjects[section.project.sbs_project_id]" class="rs-project-body">

          <!-- Контент секции -->
          <template v-if="section.dateGroups.length">
            <template v-if="groupBy === 'all' && section.dateGroups.length === 1">
              <div class="rs-card">
                <table class="rs-table">
                  <thead>
                    <tr>
                      <th class="rs-th rs-th--check">
                        <q-checkbox
                          :model-value="isGroupSelected(pi, 0)"
                          :indeterminate="isGroupPartial(pi, 0)"
                          @update:model-value="toggleGroup(pi, 0)"
                          dense
                          color="teal-7"
                        />
                      </th>
                      <th class="rs-th rs-th--idx">#</th>
                      <th class="rs-th rs-th--name">Наименование</th>
                      <th class="rs-th rs-th--unit">Ед.</th>
                      <!-- <th class="rs-th rs-th--amt">Смета</th> -->
                      <th class="rs-th rs-th--amt">Потребность</th>
                      <th class="rs-th rs-th--amt">Заказано</th>
                      <th class="rs-th rs-th--amt">Доставлено</th>
                      <th class="rs-th rs-th--amt rs-th--can-order-head" title="Сколько еще не заказали из потребности">
                        Нужно заказать
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(mat, mi) in section.dateGroups[0].materials" :key="mi" class="rs-row" :class="{'rs-row--selected': isMaterialSelected(pi, 0, mi), 'rs-row--done': isMaterialFullyOrdered(mat)}">
                      <td class="rs-td rs-td--check">
                        <q-checkbox
                          :model-value="isMaterialSelected(pi, 0, mi)"
                          @update:model-value="toggleMaterial(pi, 0, mi)"
                          dense
                          color="teal-7"
                          :disable="isMaterialFullyOrdered(mat)"
                        >
                          <q-tooltip v-if="isMaterialFullyOrdered(mat)">Заказано полностью</q-tooltip>
                        </q-checkbox>
                      </td>
                      <td class="rs-td rs-td--idx">{{ mi + 1 }}</td>
                      <td class="rs-td rs-td--name">{{ mat.material_name || '-' }}</td>
                      <td class="rs-td rs-td--unit">{{ mat.unit_name || '' }}</td>
                      <!-- <td class="rs-td rs-td--amt rs-td--smeta">{{ fmtNum(mat.smeta_amount) }}</td> -->
                      <td class="rs-td rs-td--amt rs-td--required">{{ fmtNum(mat.amount) }}</td>
                      <td class="rs-td rs-td--amt rs-td--ordered">{{ fmtNum(mat.ordered_amount) }}</td>
                      <td class="rs-td rs-td--amt rs-td--delivered">{{ fmtNum(mat.delivered_amount) }}</td>
                      <td class="rs-td rs-td--amt rs-td--can-order">{{ fmtNum(remainingToOrderAmount(mat)) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <template v-else>
              <div
                v-for="(group, gi) in section.dateGroups"
                :key="group.shipping_date"
                class="rs-card"
              >
                <div class="rs-card__header" @click="toggle(pi, gi)">
                  <q-checkbox
                    :model-value="isGroupSelected(pi, gi)"
                    :indeterminate="isGroupPartial(pi, gi)"
                    @update:model-value="toggleGroup(pi, gi)"
                    @click.stop
                    dense
                    color="teal-7"
                  />
                  <q-icon
                    :name="expanded[pi + '-' + gi] ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                    size="20px"
                    color="grey-7"
                  />
                  <span class="rs-card__date">{{ formatDate(group.shipping_date) }}</span>
                  <q-space />
                  <q-badge rounded color="blue-grey-1" text-color="blue-grey-8" class="q-mr-xs">
                    {{ group.materials.length }} мат.
                  </q-badge>
                  <q-badge rounded color="teal-1" text-color="teal-9" title="Потребность по группе">
                    {{ fmtNum(groupTotalAmount(group)) }}
                  </q-badge>
                  <q-badge
                    rounded
                    color="green-2"
                    text-color="green-10"
                    class="q-ml-xs"
                    title="Сколько еще не заказали из потребности (сумма по группе)"
                  >
                    {{ fmtNum(groupRemainingToOrder(group)) }}
                  </q-badge>
                  <q-icon
                    v-if="isGroupDemandFullyOrdered(group)"
                    name="check_circle"
                    size="22px"
                    color="positive"
                    class="q-ml-sm rs-card__complete-icon"
                    title="Потребность по группе заказана"
                  />
                </div>

                <transition name="rs-slide">
                  <div v-if="expanded[pi + '-' + gi]" class="rs-card__body">
                    <table class="rs-table">
                      <thead>
                        <tr>
                          <th class="rs-th rs-th--check"></th>
                          <th class="rs-th rs-th--idx">#</th>
                          <th class="rs-th rs-th--name">Наименование</th>
                          <th class="rs-th rs-th--unit">Ед.</th>
                          <!-- <th class="rs-th rs-th--amt">Смета</th> -->
                          <th class="rs-th rs-th--amt">Потребность</th>
                          <th class="rs-th rs-th--amt">Заказано</th>
                          <th class="rs-th rs-th--amt">Доставлено</th>
                          <th class="rs-th rs-th--amt rs-th--can-order-head" title="Сколько еще не заказали из потребности">
                            Нужно заказать
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(mat, mi) in group.materials" :key="mi" class="rs-row" :class="{'rs-row--selected': isMaterialSelected(pi, gi, mi), 'rs-row--done': isMaterialFullyOrdered(mat)}">
                          <td class="rs-td rs-td--check">
                            <q-checkbox
                              :model-value="isMaterialSelected(pi, gi, mi)"
                              @update:model-value="toggleMaterial(pi, gi, mi)"
                              dense
                              color="teal-7"
                              :disable="isMaterialFullyOrdered(mat)"
                            >
                              <q-tooltip v-if="isMaterialFullyOrdered(mat)">Заказано полностью</q-tooltip>
                            </q-checkbox>
                          </td>
                          <td class="rs-td rs-td--idx">{{ mi + 1 }}</td>
                          <td class="rs-td rs-td--name">{{ mat.material_name || '-' }}</td>
                          <td class="rs-td rs-td--unit">{{ mat.unit_name || '' }}</td>
                          <!-- <td class="rs-td rs-td--amt rs-td--smeta">{{ fmtNum(mat.smeta_amount) }}</td> -->
                          <td class="rs-td rs-td--amt rs-td--required">{{ fmtNum(mat.amount) }}</td>
                          <td class="rs-td rs-td--amt rs-td--ordered">{{ fmtNum(mat.ordered_amount) }}</td>
                          <td class="rs-td rs-td--amt rs-td--delivered">{{ fmtNum(mat.delivered_amount) }}</td>
                          <td class="rs-td rs-td--amt rs-td--can-order">{{ fmtNum(remainingToOrderAmount(mat)) }}</td>
                        </tr>
                        <tr v-if="!group.materials.length">
                          <td colspan="8" class="text-center text-grey q-pa-sm" style="font-size: 12px;">Нет позиций</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </transition>
              </div>
            </template>
          </template>

          <div v-else class="rs-section-empty">
            <q-icon name="inbox" size="22px" color="grey-4" class="q-mr-xs" />
            <span>Нет данных по проекту</span>
          </div>

          </div><!-- /rs-project-body -->
          </transition>
        </div>

        <div class="rs-summary">
          <div class="rs-summary__item">
            <q-icon name="category" size="18px" color="teal-6" />
            <span class="rs-summary__label">Материалов:</span>
            <span class="rs-summary__value">{{ totalUniqueMaterials }}</span>
          </div>
          <div class="rs-summary__item">
            <q-icon name="inventory_2" size="18px" color="teal-6" />
            <span class="rs-summary__label">Общее кол-во:</span>
            <span class="rs-summary__value">{{ fmtNum(totalAmount) }}</span>
          </div>
        </div>
      </div>

      <div v-else class="rs-empty">
        <q-icon name="inbox" size="48px" color="grey-4" />
        <div class="rs-empty__text">Нет данных о потребностях</div>
      </div>
    </template>

    <q-dialog v-model="showSupplierDialog" persistent @update:model-value="onSupplierDialogToggle">
      <q-card style="width: 1320px; max-width: 96vw;">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Выбор поставщика</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup :disable="modalSubmitting" />
        </q-card-section>

        <q-card-section v-if="modalLoading" class="column items-center q-pa-lg">
          <q-spinner color="primary" size="32px" />
          <div class="q-mt-sm text-grey">Загрузка данных по материалам...</div>
        </q-card-section>

        <q-card-section v-if="!modalLoading" class="q-pt-sm q-pb-none">
          <div class="row items-center q-gutter-sm">
            <q-input
              v-model="modalSearch"
              dense outlined clearable
              placeholder="Поиск по материалу..."
              class="sm-search-input col"
            >
              <template #prepend><q-icon name="search" /></template>
            </q-input>
            <div class="sm-sklad-label">
              <q-icon name="warehouse" size="xs" color="grey-6" class="q-mr-xs" />
              <span class="text-caption text-grey-7">Склад:</span>
              <span class="sm-sklad-name">{{ supplySelectedProject?.sklad_name || '—' }}</span>
            </div>
            <q-input
              :model-value="modalGlobalDate"
              @update:model-value="(v) => { modalGlobalDate = v ? clampShippingDate(v) : '' }"
              dense outlined
              mask="##.##.####"
              placeholder="ДД.ММ.ГГГГ"
              class="sm-global-date"
              style="max-width: 170px;"
              :disable="modalSubmitting"
            >
              <template #prepend><q-icon name="event" size="xs" /></template>
              <template #append>
                <q-icon name="event" class="cursor-pointer" size="xs">
                  <q-popup-proxy transition-show="scale" transition-hide="scale">
                    <q-date
                      :model-value="modalGlobalDate"
                      mask="DD.MM.YYYY"
                      :options="(d) => d >= tomorrowIso.replace(/-/g, '/')"
                      minimal
                      @update:model-value="(v) => { modalGlobalDate = clampShippingDate(v) }"
                    />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-btn
              flat dense no-caps size="sm" color="primary"
              label="Применить ко всем"
              :disable="!modalGlobalDate || modalSubmitting"
              @click="applyGlobalDate"
            />
          </div>
        </q-card-section>

        <q-card-section v-if="!modalLoading" class="q-pt-sm">
          <div class="sm-table-wrap">
            <table class="sm-table">
              <thead>
                <tr>
                  <th class="sm-th sm-col-name">Материал</th>
                  <th class="sm-th sm-col-orig-price">Индикативная цена / ед.</th>
                  <th class="sm-th sm-col-last-price">Цена в накладной / ед.</th>
                  <th class="sm-th sm-col-limits">Заказано / Потребность</th>
                  <th class="sm-th sm-col-qty">Кол-во / сумма</th>
                  <th class="sm-th sm-col-date">Дата отгрузки</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="mat in modalFilteredMaterials" :key="mat._rowId">
                  <tr
                    :class="{
                      'sm-row-active': getModalQty(mat._rowId) > 0,
                      'sm-row-no-agr': !mat.agreements || mat.agreements.length === 0,
                    }"
                  >
                    <td class="sm-td sm-col-name">
                      <div class="sm-mat-name">{{ mat.material_name }}</div>
                      <div class="sm-mat-agr">
                        <template v-if="getRowAgreements(mat).length === 0">
                          <span class="sm-agr-badge sm-agr-badge--none">Договор:</span>
                          <span class="sm-no-agr">Нет договора поставки</span>
                        </template>
                        <template v-else-if="getRowAgreements(mat).length === 1">
                          <span class="sm-agr-badge">Договор:</span>
                          <span class="sm-agr-text">{{ getRowAgreements(mat)[0].agreement_display_name }}</span>
                        </template>
                        <template v-else>
                          <span class="sm-agr-badge">Договор:</span>
                          <q-select
                            :model-value="modalAgreementMap[mat._rowId] || null"
                            :options="getRowAgreements(mat)"
                            option-value="contractor_agreement_list_id"
                            option-label="agreement_display_name"
                            @update:model-value="(val) => onModalAgreementChange(mat._rowId, val)"
                            dense outlined
                            emit-value map-options
                            class="sm-agr-select"
                            :disable="modalSubmitting"
                          />
                        </template>
                        <q-btn
                          v-if="!mat._isClone && canAddRow(mat)"
                          icon="add_circle_outline" flat dense round size="xs" color="primary"
                          class="q-ml-xs"
                          @click="addMaterialRow(mat)"
                          :disable="modalSubmitting"
                          title="Добавить ещё договор"
                        />
                        <q-btn
                          v-if="mat._isClone"
                          icon="remove_circle_outline" flat dense round size="xs" color="red-5"
                          class="q-ml-xs"
                          @click="removeMaterialRow(mat)"
                          :disable="modalSubmitting"
                          title="Удалить"
                        />
                        <span v-if="false" class="sm-agr-spacer"></span>
                        <q-spinner v-if="false" size="12px" color="primary" />
                        <span v-if="false" class="sm-agr-price">{{ fmtMoney(_resolvePrice(mat)) }} ₸</span>
                        <span v-if="false" class="sm-no-price-warn">Цена не заполнена</span>
                      </div>
                      <q-btn
                        flat dense no-caps size="xs" color="teal-7"
                        label="Создать договор поставки"
                        class="sm-add-agr-btn"
                        @click.stop="openAddAgreement"
                      />
                    </td>
                    <td class="sm-td sm-col-orig-price">
                      <div class="sm-cell-stack">
                        <div class="sm-cell-main">
                          <span v-if="mat.indicative_price" class="sm-agr-price">{{ fmtMoney(mat.indicative_price) }} ₸</span>
                          <span v-else class="sm-no-val">—</span>
                        </div>
                        <div class="sm-cell-sub">{{ mat.unit_name || '—' }}</div>
                      </div>
                    </td>
                    <td class="sm-td sm-col-last-price">
                      <div class="sm-cell-stack">
                        <div class="sm-cell-main">
                          <span v-if="mat.last_invoice_price" class="sm-agr-price">{{ fmtMoney(mat.last_invoice_price) }} ₸</span>
                          <span v-else class="sm-no-val">—</span>
                        </div>
                        <div class="sm-cell-sub">{{ mat.unit_name || '—' }}</div>
                      </div>
                    </td>
                    <td class="sm-td sm-col-limits">
                      <div class="sm-cell-stack">
                        <div class="sm-cell-row"><span class="sm-cell-label">Заказано:</span> {{ fmtNum(mat.ordered_cnt) }}</div>
                        <div class="sm-cell-row">
                          <span class="sm-cell-label">Потребность:</span>
                          <template v-if="mat._isClone">
                            {{ fmtNum(getRowDisplayReq(mat)) }}
                            <span class="sm-cell-sub-inline" :title="'Изначальная потребность: ' + fmtNum(getMaterialInitialReq(mat))">
                              из {{ fmtNum(getMaterialInitialReq(mat)) }}
                            </span>
                          </template>
                          <template v-else>
                            {{ fmtNum(mat._reqAmount) }}
                          </template>
                        </div>
                      </div>
                    </td>
                    <td class="sm-td sm-col-qty">
                      <div class="sm-cell-stack">
                        <q-input
                          :model-value="modalQtyText[mat._rowId] ?? ''"
                          @update:model-value="(v) => setModalQtyText(mat._rowId, v)"
                          @blur="formatModalQty(mat._rowId)"
                          dense outlined
                          inputmode="decimal"
                          placeholder="0"
                          class="sm-qty-input"
                          :input-style="{ textAlign: 'right' }"
                          :disable="modalSubmitting || isModalRowDone(mat._rowId) || getRowAgreements(mat).length === 0"
                          :error="modalQtyExceeds(mat)"
                          :error-message="'Макс: ' + fmtNum(modalCanOrder(mat))"
                          hide-bottom-space
                        />
                        <div class="sm-cell-sum">
                          <span v-if="getModalQty(mat._rowId) > 0 && mat.indicative_price" class="sm-sum-val">
                            {{ fmtMoney(getModalQty(mat._rowId) * mat.indicative_price) }} ₸
                          </span>
                          <span v-else class="sm-no-val">—</span>
                        </div>
                      </div>
                    </td>
                    <td class="sm-td sm-col-date">
                      <q-input
                        :model-value="modalShippingDate[mat._rowId] || ''"
                        @update:model-value="(v) => { modalShippingDate = { ...modalShippingDate, [mat._rowId]: v ? clampShippingDate(v) : '' } }"
                        dense outlined
                        mask="##.##.####"
                        placeholder="ДД.ММ.ГГГГ"
                        class="sm-date-input"
                        :disable="modalSubmitting || isModalRowDone(mat._rowId)"
                      >
                        <template #append>
                          <q-icon name="event" class="cursor-pointer" size="xs">
                            <q-popup-proxy transition-show="scale" transition-hide="scale">
                              <q-date
                                :model-value="modalShippingDate[mat._rowId] || ''"
                                mask="DD.MM.YYYY"
                                :options="(d) => d >= tomorrowIso.replace(/-/g, '/')"
                                minimal
                                @update:model-value="(v) => { modalShippingDate = { ...modalShippingDate, [mat._rowId]: clampShippingDate(v) } }"
                              />
                            </q-popup-proxy>
                          </q-icon>
                        </template>
                      </q-input>
                    </td>
                  </tr>
                  <tr v-if="modalRowResult[mat._rowId]" :key="'msg-' + mat._rowId"
                    :class="modalRowResult[mat._rowId].ok ? 'sm-msg-ok' : 'sm-msg-err'">
                    <td colspan="6" class="sm-msg-cell">{{ modalRowResult[mat._rowId].text }}</td>
                  </tr>
                </template>
                <tr v-if="!modalFilteredMaterials.length">
                  <td colspan="6" class="text-center text-grey q-pa-md">Ничего не найдено</td>
                </tr>
              </tbody>
              <tfoot v-if="modalTotalSum > 0">
                <tr>
                  <td colspan="4" class="sm-foot-label">Итого:</td>
                  <td class="sm-foot-sum">{{ fmtMoney(modalTotalSum) }} ₸</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </q-card-section>

        <q-card-actions v-if="!modalLoading" align="right" class="q-pt-none q-pb-md q-px-md">
          <span v-if="modalSelectedCount > 0" class="text-caption text-primary q-mr-auto">
            {{ modalSelectedCount }} позиций к созданию
          </span>
          <q-btn flat label="Закрыть" color="grey" v-close-popup no-caps :disable="modalSubmitting" />
          <q-btn
            unelevated no-caps
            color="green-7"
            label="Создать заявку"
            :loading="modalSubmitting"
            :disable="modalSelectedCount === 0"
            @click="submitSupplierModal"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    </q-tab-panel>

    <q-tab-panel name="requests" class="q-pa-none">
      <div class="rs-toolbar">
        <div class="rs-toolbar__actions">
          <q-btn-group v-if="groupedRequests.length" flat class="rs-expand-btns">
            <q-btn flat dense no-caps icon="unfold_more" size="sm" @click="expandAllReq" title="Развернуть все" />
            <q-btn flat dense no-caps icon="unfold_less" size="sm" @click="collapseAllReq" title="Свернуть все" />
          </q-btn-group>
          <q-space />
          <q-select
            ref="projectSelectRequests"
            v-model="selectedProject"
            :options="filteredProjects"
            option-label="sbs_project_name"
            option-value="sbs_project_id"
            label="Проект"
            outlined
            dense
            use-input
            input-debounce="200"
            @filter="filterProjects"
            @update:model-value="onProjectSelect"
            class="rs-project-select"
            clearable
            :loading="projectsLoading"
          >
            <template #prepend><q-icon name="folder_open" size="xs" color="grey-6" /></template>
            <template #no-option>
              <q-item><q-item-section class="text-grey">Нет результатов</q-item-section></q-item>
            </template>
          </q-select>
          <q-select
            v-model="reqMaterialFilter"
            :options="filteredReqMaterialOptions"
            option-label="material_name"
            option-value="material_id"
            label="Материал"
            outlined
            dense
            clearable
            use-input
            input-debounce="200"
            @filter="filterReqMaterialOptions"
            @update:model-value="onReqMaterialFilterChange"
            class="rs-material-filter"
          >
            <template #prepend><q-icon name="filter_list" size="xs" color="grey-6" /></template>
            <template #no-option>
              <q-item><q-item-section class="text-grey">Нет результатов</q-item-section></q-item>
            </template>
          </q-select>
        </div>
      </div>

      <div
        v-if="!selectedProject && !projectsLoading"
        class="rs-pick-project"
        role="button"
        tabindex="0"
        @click="openProjectSelectFromPrompt"
        @keydown.enter.prevent="openProjectSelectFromPrompt"
        @keydown.space.prevent="openProjectSelectFromPrompt"
      >
        <q-icon name="folder_open" size="56px" color="grey-5" class="q-mb-md" />
        <div class="rs-pick-project__text">Пожалуйста, выберите проект</div>
      </div>
      <div v-else-if="requestsLoading" class="rs-loader">
        <q-spinner-dots color="teal-7" size="48px" />
        <div class="rs-loader__text">Загрузка заявок...</div>
      </div>

      <template v-else-if="!requestsLoading && selectedProject">
        <div v-if="groupedRequests.length" class="rs-content">
          <div
            v-for="(group, gIdx) in groupedRequests"
            :key="group.required_id || gIdx"
            class="rs-card"
          >
            <div class="rs-card__header rs-req-header" @click="reqExpanded = { ...reqExpanded, [gIdx]: !reqExpanded[gIdx] }">
              <q-icon
                :name="reqExpanded[gIdx] ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                size="20px"
                color="grey-7"
              />
              <span class="rs-card__date">{{ group.required_type_name || 'Без типа' }}</span>
              <q-badge rounded color="blue-grey-1" text-color="blue-grey-8" class="q-ml-sm">
                {{ group.items.length }} заяв.
              </q-badge>
              <q-space />
              <span class="rs-req-dates">
                {{ formatDateShort(group.date_begin) }} — {{ formatDateShort(group.date_end) }}
              </span>
            </div>

            <transition name="rs-slide">
              <div v-if="reqExpanded[gIdx]" class="rs-card__body">
                <table class="rs-table">
                  <thead>
                    <tr>
                      <th class="rs-th rs-th--idx">#</th>
                      <th class="rs-th rs-th--name">Материал</th>
                      <th class="rs-th rs-th--unit">Ед.</th>
                      <th class="rs-th rs-th--amt">Кол-во</th>
                      <th class="rs-th rs-th--amt">Цена</th>
                      <th class="rs-th" style="min-width:110px">Дата отгрузки</th>
                      <th class="rs-th" style="min-width:160px">Поставщик / Договор</th>
                      <th class="rs-th" style="min-width:100px">Статус</th>
                      <th class="rs-th" style="min-width:100px">Дата создания</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, iIdx) in group.items"
                      :key="item.provider_request_item_id || iIdx"
                      class="rs-row"
                      :class="item.is_within_dates ? 'rs-row--in-range' : 'rs-row--out-range'"
                    >
                      <td class="rs-td rs-td--idx">{{ iIdx + 1 }}</td>
                      <td class="rs-td rs-td--name">{{ item.material_name || '-' }}</td>
                      <td class="rs-td rs-td--unit">{{ item.unit_name || '' }}</td>
                      <td class="rs-td rs-td--amt">{{ fmtNum(item.qty) }}</td>
                      <td class="rs-td rs-td--amt">{{ item.buy_price ? fmtMoney(item.buy_price) : '—' }}</td>
                      <td class="rs-td">
                        <div class="rs-date-cell">
                          <q-icon
                            :name="item.is_within_dates ? 'check_circle' : 'warning'"
                            :color="item.is_within_dates ? 'positive' : 'orange-8'"
                            size="16px"
                          />
                          <span>{{ formatDateShort(item.date_shipping) }}</span>
                          <q-tooltip v-if="!item.is_within_dates">
                            Дата отгрузки не входит в даты потребности ({{ formatDateShort(group.date_begin) }} — {{ formatDateShort(group.date_end) }})
                          </q-tooltip>
                        </div>
                      </td>
                      <td class="rs-td">
                        <div class="rs-contractor-cell">
                          <div v-if="item.contractor_name" class="rs-contractor-name">{{ item.contractor_name }}</div>
                          <div v-if="item.agreement_name" class="rs-agreement-name">{{ item.agreement_name }}</div>
                          <span v-if="!item.contractor_name && !item.agreement_name" class="text-grey-5">—</span>
                        </div>
                      </td>
                      <td class="rs-td">
                        <q-badge
                          :color="item.provider_request_status_name ? 'blue-grey-2' : 'grey-3'"
                          :text-color="item.provider_request_status_name ? 'blue-grey-9' : 'grey-6'"
                          class="rs-status-badge"
                        >
                          {{ item.provider_request_status_name || '—' }}
                        </q-badge>
                      </td>
                      <td class="rs-td rs-td--unit">{{ formatDateShort(item.date_create) }}</td>
                    </tr>
                    <tr v-if="!group.items.length">
                      <td colspan="9" class="text-center text-grey q-pa-sm" style="font-size:12px">Нет заявок</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </transition>
          </div>

          <div class="rs-summary">
            <div class="rs-summary__item">
              <q-icon name="receipt_long" size="18px" color="teal-6" />
              <span class="rs-summary__label">Всего заявок:</span>
              <span class="rs-summary__value">{{ totalRequestItems }}</span>
            </div>
            <div class="rs-summary__item">
              <q-icon name="check_circle" size="18px" color="positive" />
              <span class="rs-summary__label">В диапазоне дат:</span>
              <span class="rs-summary__value">{{ requestsInRange }}</span>
            </div>
            <div class="rs-summary__item">
              <q-icon name="warning" size="18px" color="orange-8" />
              <span class="rs-summary__label">Вне диапазона:</span>
              <span class="rs-summary__value">{{ requestsOutRange }}</span>
            </div>
          </div>
        </div>

        <div v-else class="rs-empty">
          <q-icon name="inbox" size="48px" color="grey-4" />
          <div class="rs-empty__text">Нет созданных заявок по выбранному проекту</div>
        </div>
      </template>
    </q-tab-panel>
    <q-tab-panel name="supplier" class="q-pa-none">
      <SupplierRequestsFromRequired
        v-if="activeTab === 'supplier'"
        :key="selectedProject && selectedProject.sbs_project_id"
        :initial-project-id="selectedProject ? selectedProject.sbs_project_id : null"
        :embedded="true"
      />
    </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script>
import instance from "@/services/api";
import SupplierRequestsFromRequired from "@/views/SupplierRequestsFromRequired";
export default {
  name: "RequiredSupply",
  components: { SupplierRequestsFromRequired },
  data() {
    return {
      activeTab: 'supply',
      projects: [],
      filteredProjects: [],
      selectedProject: null,
      projectsLoading: false,

      // multi-project supply
      projectSections: [],       // [{ project, dateGroups, loading }]
      allProjectsLoading: false,
      supplySelectedProjectId: null,
      collapsedProjects: {},     // { sbs_project_id: true } — свёрнутые проекты

      summaryMap: {},
      expanded: {},
      groupBy: 'week',
      selected: {},
      materialFilter: null,
      filteredMaterialOptions: [],
      showSupplierDialog: false,
      supplierSummary: [],

      modalLoading: false,
      modalMaterials: [],
      modalAgreementMap: {},
      modalQtyText: {},
      modalPriceLoading: {},
      modalPriceCache: {},
      modalRowResult: {},
      modalSubmitting: false,
      modalSearch: '',
      modalRowCounter: 0,
      modalShippingDate: {},
      modalGlobalDate: '',
      modalPriceText: {},

      requests: [],
      requestsLoading: false,
      reqExpanded: {},
      reqMaterialFilter: null,
      filteredReqMaterialOptions: [],
    };
  },
  computed: {
    tomorrowIso() {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    tomorrowStr() {
      return this.isoToDmy(this.tomorrowIso);
    },
    allProjectsExpanded() {
      return this.filteredProjectSections.every(s => !this.collapsedProjects[s.project.sbs_project_id]);
    },
    supplySelectedProject() {
      if (!this.supplySelectedProjectId) return null;
      const section = this.projectSections.find(s => s.project.sbs_project_id === this.supplySelectedProjectId);
      return section?.project || null;
    },
    filteredProjectSections() {
      const mid = this.materialFilter?.material_id ?? null;
      return this.projectSections.map(section => {
        if (section.loading) return section;
        const groups = mid
          ? section.dateGroups
              .map(g => ({ ...g, materials: g.materials.filter(m => m.material_id === mid) }))
              .filter(g => g.materials.length > 0)
          : section.dateGroups;
        return { ...section, dateGroups: groups };
      }).filter(s => s.loading || s.dateGroups.length > 0);
    },
    materialOptions() {
      const map = {};
      for (const section of this.projectSections) {
        for (const g of section.dateGroups) {
          for (const m of g.materials) {
            const mid = m.material_id;
            if (mid != null && !map[mid]) {
              map[mid] = { material_id: mid, material_name: m.material_name || '-' };
            }
          }
        }
      }
      return Object.values(map).sort((a, b) =>
        (a.material_name || '').localeCompare(b.material_name || '', 'ru')
      );
    },
    selectedCount() {
      return Object.keys(this.selected).length;
    },
    isSomeSelected() {
      return this.selectedCount > 0;
    },
    isAllSelected() {
      if (!this.supplySelectedProjectId) return false;
      const pi = this.filteredProjectSections.findIndex(s => s.project.sbs_project_id === this.supplySelectedProjectId);
      if (pi === -1) return false;
      const section = this.filteredProjectSections[pi];
      let total = 0;
      for (let gi = 0; gi < section.dateGroups.length; gi++) {
        for (const m of section.dateGroups[gi].materials) {
          if (!this.isMaterialFullyOrdered(m)) total++;
        }
      }
      return total > 0 && this.selectedCount === total;
    },
    totalUniqueMaterials() {
      const ids = new Set();
      for (const section of this.filteredProjectSections) {
        for (const g of section.dateGroups) {
          for (const m of g.materials) {
            ids.add(m.material_id ?? m.material_name);
          }
        }
      }
      return ids.size;
    },
    totalAmount() {
      let sum = 0;
      for (const section of this.filteredProjectSections) {
        for (const g of section.dateGroups) {
          for (const m of g.materials) {
            sum += parseFloat(m.amount) || 0;
          }
        }
      }
      return sum;
    },
    supplierSummaryTotalAmount() {
      let sum = 0;
      for (const s of this.supplierSummary) sum += s.amount;
      return sum;
    },
    modalFilteredMaterials() {
      const q = (this.modalSearch || '').toLowerCase().trim();
      if (!q) return this.modalMaterials;
      return this.modalMaterials.filter(
        m => (m.material_name || '').toLowerCase().includes(q)
      );
    },
    modalTotalSum() {
      let s = 0;
      for (const m of this.modalMaterials) {
        const qty = this.getModalQty(m._rowId);
        const price = parseFloat(m.indicative_price) || 0;
        if (qty > 0 && price) s += qty * price;
      }
      return s;
    },
    modalSelectedCount() {
      let n = 0;
      for (const m of this.modalMaterials) {
        if (this.getModalQty(m._rowId) > 0 && this.getModalSelectedAgreementId(m) && !this.isModalRowDone(m._rowId) && !this.modalQtyExceeds(m))
          n++;
      }
      return n;
    },
    reqMaterialOptions() {
      const map = {};
      for (const r of this.requests) {
        const mid = r.material_id;
        if (mid != null && !map[mid]) {
          map[mid] = { material_id: mid, material_name: r.material_name || '-' };
        }
      }
      return Object.values(map).sort((a, b) =>
        (a.material_name || '').localeCompare(b.material_name || '', 'ru')
      );
    },
    filteredRequests() {
      if (!this.reqMaterialFilter) return this.requests;
      const mid = this.reqMaterialFilter.material_id;
      return this.requests.filter(r => r.material_id === mid);
    },
    groupedRequests() {
      const map = {};
      for (const r of this.filteredRequests) {
        const key = r.required_id || '__none__';
        if (!map[key]) {
          map[key] = {
            required_id: r.required_id,
            required_type_name: r.required_type_name || '',
            date_begin: r.date_begin,
            date_end: r.date_end,
            items: [],
          };
        }
        map[key].items.push(r);
      }
      return Object.values(map);
    },
    totalRequestItems() {
      return this.filteredRequests.length;
    },
    requestsInRange() {
      return this.filteredRequests.filter(r => r.is_within_dates).length;
    },
    requestsOutRange() {
      return this.filteredRequests.filter(r => !r.is_within_dates).length;
    },
  },
  watch: {
    activeTab(val) {
      if (val === 'requests' && this.selectedProject && !this.requests.length) {
        this.loadRequests();
      }
    },
  },

  mounted() {
    this.loadProjects();
  },
  methods: {
    fmtNum(v) {
      if (v == null || v === "") return "";
      const n = Number(v);
      if (isNaN(n)) return v;
      return parseFloat(n.toFixed(2));
    },

    /** Сколько еще не заказали из потребности: потребность минус заказано (не ниже нуля). */
    remainingToOrderAmount(mat) {
      const req = parseFloat(mat.amount) || 0;
      const ord = parseFloat(mat.ordered_amount) || 0;
      const n = req - ord;
      return n > 0 ? parseFloat(n.toFixed(4)) : 0;
    },

    isMaterialFullyOrdered(mat) {
      const req = parseFloat(mat.amount) || 0;
      const ord = parseFloat(mat.ordered_amount) || 0;
      return req > 0 && ord + 1e-6 >= req;
    },

    formatDate(d) {
      if (!d) return "Без даты";
      if (this.groupBy !== 'day') return d;
      const parts = d.split("-");
      if (parts.length === 3) return `${parts[2]}.${parts[1]}.${parts[0]}`;
      return d;
    },

    formatDateShort(d) {
      if (!d) return '—';
      const s = String(d).slice(0, 10);
      const parts = s.split('-');
      if (parts.length === 3) return `${parts[2]}.${parts[1]}.${parts[0]}`;
      return s;
    },

    groupTotalAmount(group) {
      let sum = 0;
      for (const m of group.materials) {
        sum += parseFloat(m.amount) || 0;
      }
      return sum;
    },

    groupRemainingToOrder(group) {
      let sum = 0;
      for (const m of group.materials || []) {
        sum += this.remainingToOrderAmount(m);
      }
      return sum > 0 ? parseFloat(sum.toFixed(4)) : 0;
    },

    /** Есть потребность по группе и по сумме «нужно заказать» осталось 0 (заказано ≥ потребности по строкам). */
    isGroupDemandFullyOrdered(group) {
      const mats = group?.materials;
      if (!mats?.length) return false;
      if (this.groupTotalAmount(group) <= 0) return false;
      return this.groupRemainingToOrder(group) < 0.0001;
    },

    isProjectAllSelected(pi) {
      const section = this.filteredProjectSections[pi];
      if (!section || section.loading) return false;
      let total = 0;
      for (let gi = 0; gi < section.dateGroups.length; gi++) {
        for (const m of section.dateGroups[gi].materials) {
          if (!this.isMaterialFullyOrdered(m)) total++;
        }
      }
      if (total === 0) return false;
      for (let gi = 0; gi < section.dateGroups.length; gi++) {
        for (let mi = 0; mi < section.dateGroups[gi].materials.length; mi++) {
          const m = section.dateGroups[gi].materials[mi];
          if (!this.isMaterialFullyOrdered(m) && !this.selected[this._matKey(pi, gi, mi)]) return false;
        }
      }
      return true;
    },

    isProjectSomeSelected(pi) {
      const section = this.filteredProjectSections[pi];
      if (!section || section.loading) return false;
      for (let gi = 0; gi < section.dateGroups.length; gi++) {
        for (let mi = 0; mi < section.dateGroups[gi].materials.length; mi++) {
          if (this.selected[this._matKey(pi, gi, mi)]) return true;
        }
      }
      return false;
    },

    toggleProjectAll(pi, val) {
      const section = this.filteredProjectSections[pi];
      if (!section) return;
      const projectId = section.project.sbs_project_id;

      if (this.supplySelectedProjectId && this.supplySelectedProjectId !== projectId) {
        this.selected = {};
      }

      const copy = { ...this.selected };
      if (val) {
        for (let gi = 0; gi < section.dateGroups.length; gi++) {
          for (let mi = 0; mi < section.dateGroups[gi].materials.length; mi++) {
            if (this.isMaterialFullyOrdered(section.dateGroups[gi].materials[mi])) continue;
            copy[this._matKey(pi, gi, mi)] = true;
          }
        }
      } else {
        for (let gi = 0; gi < section.dateGroups.length; gi++) {
          for (let mi = 0; mi < section.dateGroups[gi].materials.length; mi++) {
            delete copy[this._matKey(pi, gi, mi)];
          }
        }
      }
      this.selected = copy;
      this.supplySelectedProjectId = Object.keys(copy).length > 0 ? projectId : null;
    },

    toggleProject(projectId) {
      this.collapsedProjects = {
        ...this.collapsedProjects,
        [projectId]: !this.collapsedProjects[projectId],
      };
    },
    toggleAllProjects(expand) {
      if (expand) {
        this.collapsedProjects = {};
      } else {
        const collapsed = {};
        for (const s of this.filteredProjectSections) {
          collapsed[s.project.sbs_project_id] = true;
        }
        this.collapsedProjects = collapsed;
      }
    },

    toggle(pi, gi) {
      const key = `${pi}-${gi}`;
      this.expanded = { ...this.expanded, [key]: !this.expanded[key] };
    },

    _matKey(pi, gi, mi) {
      return `${pi}-${gi}-${mi}`;
    },

    isMaterialSelected(pi, gi, mi) {
      return !!this.selected[this._matKey(pi, gi, mi)];
    },

    toggleMaterial(pi, gi, mi) {
      const section = this.filteredProjectSections[pi];
      const group = section?.dateGroups[gi];
      const mat = group?.materials?.[mi];
      if (mat && this.isMaterialFullyOrdered(mat)) return;

      const projectId = section?.project?.sbs_project_id;
      // при выборе материала из другого проекта сбрасываем предыдущий выбор
      if (this.supplySelectedProjectId && this.supplySelectedProjectId !== projectId) {
        this.selected = {};
      }

      const key = this._matKey(pi, gi, mi);
      const copy = { ...this.selected };
      if (copy[key]) delete copy[key];
      else copy[key] = true;
      this.selected = copy;
      this.supplySelectedProjectId = Object.keys(copy).length > 0 ? projectId : null;
    },

    isGroupSelected(pi, gi) {
      const section = this.filteredProjectSections[pi];
      const group = section?.dateGroups[gi];
      if (!group || !group.materials.length) return false;
      const selectable = group.materials.filter(m => !this.isMaterialFullyOrdered(m));
      if (!selectable.length) return false;
      return group.materials.every((m, mi) =>
        this.isMaterialFullyOrdered(m) || this.selected[this._matKey(pi, gi, mi)]
      );
    },

    isGroupPartial(pi, gi) {
      const section = this.filteredProjectSections[pi];
      const group = section?.dateGroups[gi];
      if (!group || !group.materials.length) return false;
      const some = group.materials.some((m, mi) =>
        !this.isMaterialFullyOrdered(m) && this.selected[this._matKey(pi, gi, mi)]
      );
      return some && !this.isGroupSelected(pi, gi);
    },

    toggleGroup(pi, gi) {
      const section = this.filteredProjectSections[pi];
      const group = section?.dateGroups[gi];
      if (!group) return;

      const projectId = section?.project?.sbs_project_id;
      if (this.supplySelectedProjectId && this.supplySelectedProjectId !== projectId) {
        this.selected = {};
      }

      const allSelected = this.isGroupSelected(pi, gi);
      const copy = { ...this.selected };
      for (let mi = 0; mi < group.materials.length; mi++) {
        if (this.isMaterialFullyOrdered(group.materials[mi])) continue;
        const key = this._matKey(pi, gi, mi);
        if (allSelected) delete copy[key];
        else copy[key] = true;
      }
      this.selected = copy;
      this.supplySelectedProjectId = Object.keys(copy).length > 0 ? projectId : null;
    },

    toggleSelectAll(val) {
      if (val) {
        // выбираем все в текущем проекте, или в первом доступном
        let targetPi = -1;
        if (this.supplySelectedProjectId) {
          targetPi = this.filteredProjectSections.findIndex(
            s => s.project.sbs_project_id === this.supplySelectedProjectId
          );
        }
        if (targetPi === -1) {
          for (let pi = 0; pi < this.filteredProjectSections.length; pi++) {
            const s = this.filteredProjectSections[pi];
            if (!s.loading && s.dateGroups.some(g => g.materials.some(m => !this.isMaterialFullyOrdered(m)))) {
              targetPi = pi;
              break;
            }
          }
        }
        if (targetPi === -1) { this.selected = {}; return; }

        const section = this.filteredProjectSections[targetPi];
        const copy = {};
        for (let gi = 0; gi < section.dateGroups.length; gi++) {
          for (let mi = 0; mi < section.dateGroups[gi].materials.length; mi++) {
            if (this.isMaterialFullyOrdered(section.dateGroups[gi].materials[mi])) continue;
            copy[this._matKey(targetPi, gi, mi)] = true;
          }
        }
        this.selected = copy;
        this.supplySelectedProjectId = section.project.sbs_project_id;
      } else {
        this.selected = {};
        this.supplySelectedProjectId = null;
      }
    },

    expandAll() {
      const exp = {};
      for (let pi = 0; pi < this.filteredProjectSections.length; pi++) {
        for (let gi = 0; gi < this.filteredProjectSections[pi].dateGroups.length; gi++) {
          exp[`${pi}-${gi}`] = true;
        }
      }
      this.expanded = exp;
    },

    collapseAll() {
      this.expanded = {};
    },

    filterProjects(val, update) {
      update(() => {
        const needle = (val || "").toLowerCase();
        this.filteredProjects = this.projects.filter(
          (p) => (p.sbs_project_name || "").toLowerCase().includes(needle)
        );
      });
    },

    openProjectSelectFromPrompt() {
      this.$nextTick(() => {
        let c = this.$refs['projectSelectRequests'];
        if (Array.isArray(c)) c = c[0];
        if (c && typeof c.showPopup === 'function') c.showPopup();
      });
    },

    async loadProjects() {
      this.projectsLoading = true;
      this.allProjectsLoading = true;
      try {
        const { data } = await instance().get("/required/supply/projects/");
        this.projects = data?.data || [];
        this.filteredProjects = [...this.projects];
        if (this.projects.length) {
          await this.loadAllProjectsSupplyData();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.projectsLoading = false;
        this.allProjectsLoading = false;
      }
    },

    async onProjectSelect(project) {
      // используется только для вкладки «Созданные заявки»
      this.requests = [];
      this.reqExpanded = {};
      this.reqMaterialFilter = null;
      if (!project) return;
      await this.loadRequests();
    },

    onGroupByChange() {
      if (this.projects.length) this.loadAllProjectsSupplyData();
    },

    filterMaterialOptions(val, update) {
      update(() => {
        const needle = (val || '').toLowerCase();
        this.filteredMaterialOptions = this.materialOptions.filter(
          m => (m.material_name || '').toLowerCase().includes(needle)
        );
      });
    },

    onMaterialFilterChange() {
      this.selected = {};
      this.supplySelectedProjectId = null;
      this.expanded = {};
    },

    onSupplierDialogToggle(val) {
      if (val) return;
      this.selected = {};
      this.supplySelectedProjectId = null;
      if (this.projects.length) {
        this.loadAllProjectsSupplyData();
      }
    },

    async openSupplierModal() {
      const byMaterial = {};
      const earliestDate = {};
      for (const [key] of Object.entries(this.selected)) {
        const parts = key.split('-').map(Number);
        const [pi, gi, mi] = parts;
        const section = this.filteredProjectSections[pi];
        if (!section) continue;
        const group = section.dateGroups[gi];
        if (!group) continue;
        const mat = group.materials[mi];
        if (!mat) continue;
        const mid = mat.material_id ?? mat.material_name;
        if (!byMaterial[mid]) {
          byMaterial[mid] = {
            material_name: mat.material_name || '-',
            unit_name: mat.unit_name || '',
            amount: 0,
            ordered_amount: 0,
            sbs_sklad_id: mat.sbs_sklad_id || null,
          };
        }
        byMaterial[mid].amount += parseFloat(mat.amount) || 0;
        byMaterial[mid].ordered_amount += parseFloat(mat.ordered_amount) || 0;
        const sd = mat.shipping_date;
        if (sd) {
          const d = sd.length === 10 && sd[4] === '-' ? sd : null;
          if (d && (!earliestDate[mid] || d < earliestDate[mid])) {
            earliestDate[mid] = d;
          }
        }
      }
      this.supplierSummary = Object.values(byMaterial).map(s => ({ ...s, amount: parseFloat(s.amount.toFixed(4)) }));

      this.modalMaterials = [];
      this.modalAgreementMap = {};
      this.modalQtyText = {};
      this.modalPriceLoading = {};
      this.modalPriceCache = {};
      this.modalPriceText = {};
      this.modalRowResult = {};
      this.modalSubmitting = false;
      this.modalSearch = '';
      this.modalRowCounter = 0;
      this.modalShippingDate = {};
      this.modalGlobalDate = '';
      this.showSupplierDialog = true;
      this.modalLoading = true;

      const materialIds = Object.keys(byMaterial).map(Number).filter(Boolean);
      if (!materialIds.length) { this.modalLoading = false; return; }

      try {
        const { data } = await instance().post('/required/supply/materials-info/', {
          sbs_project_id: this.supplySelectedProject.sbs_project_id,
          material_ids: materialIds,
        });
        const rows = data?.data || [];
        this.modalMaterials = rows.map((r) => {
          const sel = byMaterial[r.material_id];
          const orderedFromTable = sel != null ? parseFloat(sel.ordered_amount) || 0 : parseFloat(r.ordered_cnt) || 0;
          return {
            ...r,
            _rowId: String(r.material_id),
            _reqAmount: sel?.amount || 0,
            ordered_cnt: orderedFromTable,
            sbs_sklad_id: sel?.sbs_sklad_id || null,
          };
        });
        const agrMap = {};
        const qtyText = {};
        const dateMap = {};
        const priceText = {};
        for (const m of this.modalMaterials) {
          if (m.agreements && m.agreements.length) {
            agrMap[m._rowId] = m.agreements[0];
          }
          const remaining = Math.max(0, parseFloat((m._reqAmount - (m.ordered_cnt || 0)).toFixed(4)));
          qtyText[m._rowId] = remaining > 0 ? String(remaining) : '';
          dateMap[m._rowId] = this.clampShippingDate(earliestDate[m.material_id]);
          const p = m.indicative_price;
          priceText[m._rowId] = p != null && p > 0 ? String(p) : '';
        }
        this.modalAgreementMap = agrMap;
        this.modalQtyText = qtyText;
        this.modalShippingDate = dateMap;
        this.modalPriceText = priceText;
      } catch (e) {
        console.error(e);
      } finally {
        this.modalLoading = false;
      }
    },

    fmtMoney(v) {
      if (v == null || v === '') return '';
      if (typeof v === 'string') {
        const s = v.trim().replace(',', '.');
        if (!s || isNaN(Number(s))) return v;
        const negative = s.startsWith('-');
        const abs = negative ? s.slice(1) : s;
        const [intPart, decPart = ''] = abs.split('.');
        const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
        const result = decPart ? `${intFormatted},${decPart}` : intFormatted;
        return negative ? `-${result}` : result;
      }
      const n = Number(v);
      if (isNaN(n)) return v;
      return n.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 20 });
    },

    getModalSelectedAgreementId(mat) {
      const agr = this.modalAgreementMap[mat._rowId];
      if (!agr) {
        const avail = this.getRowAgreements(mat);
        if (avail && avail.length === 1) return avail[0].contractor_agreement_list_id;
        return null;
      }
      return agr.contractor_agreement_list_id ?? agr;
    },

    getModalPrice(mat) {
      const txt = this.modalPriceText[mat._rowId];
      if (txt !== undefined && txt !== '') {
        const n = parseFloat(txt);
        return isNaN(n) ? null : n;
      }
      return null;
    },

    getModalPriceNum(rowId) {
      const txt = this.modalPriceText[rowId];
      if (txt === undefined || txt === '') return 0;
      const n = parseFloat(txt);
      return isNaN(n) ? 0 : n;
    },

    setModalPriceText(rowId, val) {
      this.modalPriceText = { ...this.modalPriceText, [rowId]: val };
    },

    formatModalPrice(rowId) {
      const n = this.getModalPriceNum(rowId);
      this.modalPriceText = { ...this.modalPriceText, [rowId]: n > 0 ? String(parseFloat(n.toFixed(2))) : (n === 0 ? '' : String(n)) };
    },

    _resolvePrice(mat) {
      const agrId = this.getModalSelectedAgreementId(mat);
      if (!agrId) return mat.material_price || null;
      const cached = this.modalPriceCache[`${mat.material_id}_${agrId}`];
      if (cached !== undefined) return cached;
      return mat.material_price || null;
    },

    getModalQty(rowId) {
      const raw = this.modalQtyText[rowId];
      if (raw === undefined || raw === '') return 0;
      return parseFloat(raw) || 0;
    },

    setModalQtyText(rowId, val) {
      this.modalQtyText = { ...this.modalQtyText, [rowId]: val };
    },

    formatModalQty(rowId) {
      const n = this.getModalQty(rowId);
      this.modalQtyText = { ...this.modalQtyText, [rowId]: n > 0 ? String(parseFloat(n.toFixed(4))) : '' };
    },

    modalCanOrder(mat) {
      const req = this.getMaterialInitialReq(mat);
      const ordered = parseFloat(mat.ordered_cnt) || 0;
      const total = req - ordered;
      if (total <= 0) return 0;
      let siblingQty = 0;
      for (const m of this.modalMaterials) {
        if (m.material_id === mat.material_id && m._rowId !== mat._rowId) {
          siblingQty += this.getModalQty(m._rowId);
        }
      }
      const can = total - siblingQty;
      return can > 0 ? parseFloat(can.toFixed(4)) : 0;
    },

    getMaterialInitialReq(mat) {
      let req = 0;
      for (const m of this.modalMaterials) {
        if (m.material_id !== mat.material_id) continue;
        const r = parseFloat(m._reqAmount) || 0;
        if (r > req) req = r;
      }
      return req;
    },

    getRowDisplayReq(mat) {
      const req = this.getMaterialInitialReq(mat);
      const ordered = parseFloat(mat.ordered_cnt) || 0;
      let usedByOthers = 0;
      for (const m of this.modalMaterials) {
        if (m.material_id !== mat.material_id) continue;
        if (m._rowId === mat._rowId) continue;
        usedByOthers += this.getModalQty(m._rowId);
      }
      const left = req - ordered - usedByOthers;
      return left > 0 ? parseFloat(left.toFixed(4)) : 0;
    },

    modalQtyExceeds(mat) {
      return this.getModalQty(mat._rowId) > this.modalCanOrder(mat);
    },

    isoToDmy(d) {
      if (!d) return '';
      if (typeof d !== 'string') return '';
      if (d.length === 10 && d[4] === '-') {
        return `${d.slice(8, 10)}.${d.slice(5, 7)}.${d.slice(0, 4)}`;
      }
      return d;
    },

    dmyToIso(d) {
      if (!d) return '';
      if (typeof d !== 'string') return '';
      if (d.length === 10 && d[2] === '.') {
        return `${d.slice(6, 10)}-${d.slice(3, 5)}-${d.slice(0, 2)}`;
      }
      if (d.length === 10 && d[4] === '-') return d;
      return '';
    },

    clampShippingDate(d) {
      const tIso = this.tomorrowIso;
      const iso = this.dmyToIso(d) || this.dmyToIso(this.isoToDmy(d));
      const cmpIso = iso || tIso;
      const finalIso = cmpIso < tIso ? tIso : cmpIso;
      return this.isoToDmy(finalIso);
    },

    applyGlobalDate() {
      if (!this.modalGlobalDate) return;
      this.modalGlobalDate = this.clampShippingDate(this.modalGlobalDate);
      const dateMap = {};
      for (const m of this.modalMaterials) {
        dateMap[m._rowId] = this.modalGlobalDate;
      }
      this.modalShippingDate = dateMap;
    },

    isModalRowDone(rowId) {
      const r = this.modalRowResult[rowId];
      return r && r.ok;
    },

    getRowAgreements(mat) {
      if (!mat.agreements || !mat.agreements.length) return [];
      const usedIds = new Set();
      for (const m of this.modalMaterials) {
        if (m.material_id !== mat.material_id || m._rowId === mat._rowId) continue;
        const agr = this.modalAgreementMap[m._rowId];
        const id = agr?.contractor_agreement_list_id ?? agr;
        if (id) usedIds.add(id);
      }
      if (!usedIds.size) return mat.agreements;
      return mat.agreements.filter(a => !usedIds.has(a.contractor_agreement_list_id));
    },

    openAddAgreement() {
      const pid = this.supplySelectedProject?.sbs_project_id;
      const url = `/contractor-agreement-list?add=1${pid ? '&sbs_project_id=' + pid : ''}`;
      window.open(url, '_blank');
    },

    canAddRow(mat) {
      if (!mat.agreements || mat.agreements.length < 2) return false;
      const siblingCount = this.modalMaterials.filter(m => m.material_id === mat.material_id).length;
      return siblingCount < mat.agreements.length;
    },

    addMaterialRow(mat) {
      this.modalRowCounter++;
      const newRowId = `${mat.material_id}_${this.modalRowCounter}`;
      const idx = this.modalMaterials.findIndex(m => m._rowId === mat._rowId);
      const clone = {
        ...mat,
        _rowId: newRowId,
        _isClone: true,
        _reqAmount: 0,
      };
      const arr = [...this.modalMaterials];
      arr.splice(idx + 1, 0, clone);
      this.modalMaterials = arr;
      this.modalShippingDate = { ...this.modalShippingDate, [newRowId]: this.clampShippingDate(this.modalShippingDate[mat._rowId]) };

      this.$nextTick(() => {
        const avail = this.getRowAgreements(clone);
        if (avail.length) {
          this.onModalAgreementChange(newRowId, avail[0]);
        }
      });
    },

    removeMaterialRow(mat) {
      this.modalMaterials = this.modalMaterials.filter(m => m._rowId !== mat._rowId);
      const { [mat._rowId]: _a, ...restAgr } = this.modalAgreementMap;
      this.modalAgreementMap = restAgr;
      const { [mat._rowId]: _q, ...restQty } = this.modalQtyText;
      this.modalQtyText = restQty;
      const { [mat._rowId]: _p, ...restPrice } = this.modalPriceText;
      this.modalPriceText = restPrice;
    },

    async onModalAgreementChange(rowId, agr) {
      this.modalAgreementMap = { ...this.modalAgreementMap, [rowId]: agr };
      const mat = this.modalMaterials.find(m => m._rowId === rowId);
      const materialId = mat?.material_id ?? rowId;
      const agrId = agr?.contractor_agreement_list_id ?? agr;
      if (!agrId) return;
      const cacheKey = `${materialId}_${agrId}`;
      if (this.modalPriceCache[cacheKey] !== undefined) {
        const p = this.modalPriceCache[cacheKey];
        this.modalPriceText = { ...this.modalPriceText, [rowId]: p != null && p > 0 ? String(p) : '' };
        return;
      }

      this.modalPriceLoading = { ...this.modalPriceLoading, [rowId]: true };
      try {
        const { data } = await instance().get('/project/provider_requests/material-price-by-agreement/', {
          params: { material_id: materialId, contractor_agreement_list_id: agrId },
        });
        const price = data?.data?.price ?? data?.price ?? null;
        this.modalPriceCache = { ...this.modalPriceCache, [cacheKey]: price };
        this.modalPriceText = { ...this.modalPriceText, [rowId]: price != null && price > 0 ? String(price) : '' };
      } catch (e) {
        console.error(e);
      } finally {
        this.modalPriceLoading = { ...this.modalPriceLoading, [rowId]: false };
      }
    },

    async submitSupplierModal() {
      this.modalSubmitting = true;
      const items = [];
      for (const mat of this.modalMaterials) {
        const qty = this.getModalQty(mat._rowId);
        const agrId = this.getModalSelectedAgreementId(mat);
        if (qty <= 0 || !agrId || this.isModalRowDone(mat._rowId) || this.modalQtyExceeds(mat)) continue;
        items.push({
          _rowId: mat._rowId,
          material_id: mat.material_id,
          contractor_agreement_list_id: agrId,
          qty,
          buy_price: parseFloat(mat.indicative_price) || 0,
          date_shipping: this.dmyToIso(this.clampShippingDate(this.modalShippingDate[mat._rowId])),
          sbs_sklad_id: mat.sbs_sklad_id || null,
        });
      }
      if (!items.length) { this.modalSubmitting = false; return; }
      try {
        const { data } = await instance().post('/required/supply/create-request/', {
          sbs_project_id: this.supplySelectedProject.sbs_project_id,
          items,
        });
        const results = {};
        for (const r of (data?.results || [])) {
          results[r._rowId] = r.ok
            ? { ok: true, text: 'Заявка создана' }
            : { ok: false, text: r.error || 'Ошибка создания' };
        }
        this.modalRowResult = { ...this.modalRowResult, ...results };
      } catch (e) {
        const msg = e?.response?.data?.error || 'Ошибка создания';
        const results = {};
        for (const it of items) {
          results[it._rowId] = { ok: false, text: msg };
        }
        this.modalRowResult = { ...this.modalRowResult, ...results };
      }
      this.modalSubmitting = false;
    },

    async loadRequests() {
      if (!this.selectedProject) return;
      this.requestsLoading = true;
      this.reqExpanded = {};
      this.reqMaterialFilter = null;
      try {
        const { data } = await instance().post('/required/supply/requests-read/', {
          sbs_project_id: this.selectedProject.sbs_project_id,
        });
        this.requests = data?.data || [];
        const exp = {};
        this.groupedRequests.forEach((_, i) => { exp[i] = true; });
        this.reqExpanded = exp;
      } catch (e) {
        console.error(e);
      } finally {
        this.requestsLoading = false;
      }
    },

    expandAllReq() {
      const exp = {};
      for (let i = 0; i < this.groupedRequests.length; i++) exp[i] = true;
      this.reqExpanded = exp;
    },

    collapseAllReq() {
      this.reqExpanded = {};
    },

    filterReqMaterialOptions(val, update) {
      update(() => {
        const needle = (val || '').toLowerCase();
        this.filteredReqMaterialOptions = this.reqMaterialOptions.filter(
          m => (m.material_name || '').toLowerCase().includes(needle)
        );
      });
    },

    onReqMaterialFilterChange() {
      this.reqExpanded = {};
      this.$nextTick(() => {
        const exp = {};
        this.groupedRequests.forEach((_, i) => { exp[i] = true; });
        this.reqExpanded = exp;
      });
    },

    async loadAllProjectsSupplyData() {
      this.projectSections = this.projects.map(p => ({
        project: p,
        dateGroups: [],
        loading: true,
      }));
      this.selected = {};
      this.supplySelectedProjectId = null;
      this.expanded = {};
      await Promise.all(this.projects.map(p => this.loadSupplyData(p)));
      // свернуть все проекты после загрузки
      const collapsed = {};
      for (const s of this.projectSections) {
        collapsed[s.project.sbs_project_id] = true;
      }
      this.collapsedProjects = collapsed;
    },

    async loadSupplyData(project) {
      const sectionIdx = this.projectSections.findIndex(
        s => s.project.sbs_project_id === project.sbs_project_id
      );
      if (sectionIdx === -1) return;

      const setSection = (patch) => {
        const updated = [...this.projectSections];
        updated[sectionIdx] = { ...updated[sectionIdx], ...patch };
        this.projectSections = updated;
      };

      setSection({ loading: true });
      try {
        const pid = project.sbs_project_id;
        const [supplyResp, summaryResp] = await Promise.all([
          instance().post("/required/supply/read/", {
            sbs_project_id: pid,
            group_by: this.groupBy,
          }),
          instance().post("/required/supply/material-summary/", {
            sbs_project_id: pid,
          }).catch(() => ({ data: { data: [] } })),
        ]);

        const sMap = {};
        for (const row of (summaryResp.data?.data || [])) {
          sMap[row.material_id] = row;
        }

        const groups = supplyResp.data?.data || [];
        for (const g of groups) {
          for (const m of g.materials) {
            const s = sMap[m.material_id];
            if (s) {
              m.smeta_amount = s.smeta_amount;
              m.required_amount = s.required_amount;
            }
          }
        }
        setSection({ loading: false, dateGroups: groups });
      } catch (e) {
        console.error(e);
        setSection({ loading: false });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.rs-page {
  padding: 20px 24px;
  max-width: 1400px;
  margin: 0 auto;
}

/* ── Toolbar ── */
.rs-toolbar {
  margin-bottom: 8px;
}
.rs-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 14px;
  background: #f8faf9;
  border: 1px solid #e4ece7;
  border-radius: 10px;
  overflow-x: auto;
  min-height: 48px;
}
.rs-project-select {
  flex: 0 1 auto;
  width: 280px;
  min-width: 240px;
  max-width: 320px;
  margin-right: 4px;
  align-self: center;
}
.rs-material-filter {
  flex: 0 1 auto;
  width: 240px;
  min-width: 200px;
  max-width: 280px;
  align-self: center;
}

/* Одна строка в q-select: при сильном сжатии flex Quasar даёт auto-height и переносит текст. */
.rs-project-select :deep(.q-field__control),
.rs-material-filter :deep(.q-field__control) {
  min-height: 40px;
}
.rs-project-select :deep(.q-field__control-container),
.rs-material-filter :deep(.q-field__control-container) {
  flex-wrap: nowrap;
  overflow: hidden;
}
.rs-project-select :deep(.q-field__native),
.rs-material-filter :deep(.q-field__native) {
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.rs-project-select :deep(.q-field__input),
.rs-material-filter :deep(.q-field__input) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rs-group-toggle {
  flex-shrink: 0;
  border: 1px solid #d4ddd7;
  border-radius: 8px;
  overflow: hidden;
}
.rs-check-all {
  font-size: 13px;
  white-space: nowrap;
  padding-left: 2px;
}
.rs-sel-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  white-space: nowrap;
}
.rs-expand-btns {
  flex-shrink: 0;
  border: 1px solid #d4ddd7;
  border-radius: 6px;
  margin-left: 4px;
}

/* ── Loader ── */
.rs-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
}
.rs-loader__text {
  margin-top: 12px;
  color: #78909c;
  font-size: 14px;
}

.rs-pick-project {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: min(420px, 50vh);
  padding: 40px 24px 56px;
  text-align: center;
  cursor: pointer;
  border-radius: 12px;
  outline: none;
  transition: background 0.15s, box-shadow 0.15s;

  &:hover {
    background: rgba(0, 105, 92, 0.04);
    box-shadow: inset 0 0 0 1px rgba(0, 105, 92, 0.12);
  }
  &:focus-visible {
    box-shadow: inset 0 0 0 2px rgba(0, 137, 123, 0.45);
  }
}
.rs-pick-project__text {
  font-size: 1.125rem;
  font-weight: 500;
  color: #546e7a;
  line-height: 1.45;
  max-width: 360px;
}

/* ── Empty state ── */
.rs-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  gap: 12px;
}
.rs-empty__text {
  color: #90a4ae;
  font-size: 15px;
}

/* ── Content ── */
.rs-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ── Project section ── */
.rs-project-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px 16px;
  background: #fff;
  border: 1.5px solid #c8e0d4;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 105, 80, 0.05);
}
.rs-project-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 2px solid #d4ece2;
  margin-bottom: 2px;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.15s;

  &:hover { opacity: 0.82; }
}
.rs-project-header__arrow {
  flex-shrink: 0;
  transition: transform 0.2s;
}
.rs-project-header__icon {
  flex-shrink: 0;
}
.rs-project-header__name {
  font-weight: 700;
  font-size: 14px;
  color: #1a3d2b;
  letter-spacing: 0.1px;
}
.rs-project-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
}
.rs-section-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  color: #b0bec5;
  font-size: 13px;
  background: #f9f9f9;
  border: 1px dashed #e0e0e0;
  border-radius: 8px;
}

/* ── Card (date group / all-materials) ── */
.rs-card {
  border: 1px solid #e0ebe4;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04), 0 1px 2px rgba(16, 24, 40, 0.02);
}
.rs-card__header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  gap: 8px;
  cursor: pointer;
  background: linear-gradient(to right, #f5faf7, #f0f6f2);
  transition: background 0.15s;
  user-select: none;

  &:hover { background: linear-gradient(to right, #ebf3ed, #e6efe9); }
}
.rs-card__date {
  font-weight: 600;
  font-size: 14px;
  color: #2d3e33;
}
.rs-card__complete-icon {
  flex-shrink: 0;
}
.rs-card__body {
  border-top: 1px solid #e0ebe4;
}

/* ── Table ── */
.rs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.rs-th {
  padding: 7px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #6b8f7b;
  background: #f0f6f2;
  border-bottom: 1px solid #dce8e0;
  white-space: nowrap;
}
.rs-th--check { width: 36px; text-align: center; }
.rs-td--check { text-align: center; padding: 2px 4px; }
.rs-th--idx   { width: 40px; text-align: center; }
.rs-th--name  { min-width: 200px; }
.rs-th--unit  { width: 60px; text-align: center; }
.rs-th--amt   { width: 100px; text-align: right; }
.rs-th--can-order-head {
  width: 128px;
  max-width: 140px;
  text-align: right;
  line-height: 1.25;
  white-space: normal;
  vertical-align: bottom;
}

.rs-td {
  padding: 6px 12px;
  border-bottom: 1px solid #f0f4f1;
  vertical-align: middle;
}
.rs-td--idx  { text-align: center; color: #b0bec5; font-size: 12px; }
.rs-td--name { word-break: break-word; color: #37474f; }
.rs-td--unit { text-align: center; color: #90a4ae; font-size: 12px; }
.rs-td--amt  { text-align: right; font-weight: 600; color: #2d3e33; font-variant-numeric: tabular-nums; }
.rs-td--smeta { color: #78909c; font-weight: 500; }
.rs-td--required { color: #e65100; }
.rs-td--ordered { color: #1565c0; }
.rs-td--delivered { color: #2e7d32; }
.rs-td--can-order {
  font-size: 17px;
  font-weight: 800;
  color: #0d4a3a;
  letter-spacing: -0.02em;
}

.rs-row {
  transition: background 0.12s;
  &:hover { background: #f7fbf8; }
  &:last-child .rs-td { border-bottom: none; }
}
.rs-row--selected {
  background: #edf7f0;
  &:hover { background: #e5f2e9; }
}
.rs-row--done {
  background: #fafafa;
  color: #9e9e9e;
  .rs-td { color: #9e9e9e; }
  &:hover { background: #f5f5f5; }
}

/* ── Summary bar ── */
.rs-summary {
  margin-top: 12px;
  padding: 12px 20px;
  background: linear-gradient(to right, #f0f7f2, #e8f1eb);
  border-radius: 10px;
  border: 1px solid #d8e5dc;
  display: flex;
  gap: 36px;
}
.rs-summary__item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rs-summary__label {
  font-size: 13px;
  color: #6b8f7b;
  font-weight: 500;
}
.rs-summary__value {
  font-size: 16px;
  font-weight: 700;
  color: #1a2e22;
}

/* ── Modal ── */
.sm-search-input {
  max-width: 320px;
}
.sm-sklad-label {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  white-space: nowrap;
}
.sm-sklad-name {
  font-weight: 600;
  color: #37474f;
  font-size: 13px;
}
.sm-global-date {
  flex-shrink: 0;
}
.sm-table-wrap {
  max-height: 60vh;
  overflow-y: auto;
  border: 1px solid #e0e8e3;
  border-radius: 8px;
}
.sm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.sm-th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 9px 10px;
  text-align: left;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #5a7d6a;
  background: #f0f6f2;
  border-bottom: 2px solid #d4e2d9;
  white-space: nowrap;
}
.sm-td {
  padding: 9px 10px;
  border-bottom: 1px solid #f0f4f1;
  vertical-align: top;
}

.sm-col-name { min-width: 220px; }
.sm-col-orig-price { width: 120px; text-align: right; }
.sm-col-last-price { width: 120px; text-align: right; }
.sm-col-limits { width: 160px; }
.sm-col-qty { width: 140px; text-align: right; }
.sm-col-date { width: 140px; }
.sm-date-input { min-width: 130px; }

.sm-mat-name {
  font-weight: 600;
  color: #2d3e33;
  margin-bottom: 4px;
  line-height: 1.35;
}
.sm-mat-agr {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}
.sm-add-agr-btn {
  margin-top: 2px;
  font-size: 11px !important;
}
.sm-agr-badge {
  font-size: 11px;
  color: #90a4ae;
  white-space: nowrap;
}
.sm-agr-badge--none { color: #e53935; }
.sm-no-agr {
  font-size: 11px;
  color: #e53935;
  font-style: italic;
}
.sm-agr-text { font-size: 12px; color: #455a64; white-space: nowrap; }
.sm-agr-spacer { flex: 1 1 auto; }
.sm-agr-price { color: #00897b; font-weight: 600; font-size: 12px; white-space: nowrap; }
.sm-agr-select {
  min-width: 180px;
  max-width: 280px;
  font-size: 12px;
}
.sm-no-price-warn {
  font-size: 11px;
  color: #e65100;
  font-weight: 500;
  white-space: nowrap;
}
.sm-no-price-hint {
  font-size: 11px;
  color: #e65100;
  text-align: right;
  margin-top: 1px;
}

.sm-cell-stack { display: flex; flex-direction: column; gap: 2px; }
.sm-cell-sub-inline { font-size: 11px; color: #78909c; margin-left: 4px; }
.sm-cell-main { font-weight: 600; color: #37474f; text-align: right; }
.sm-cell-sub { font-size: 11px; color: #90a4ae; text-align: right; }
.sm-cell-row { font-size: 12px; line-height: 1.6; }
.sm-cell-label { color: #90a4ae; font-size: 11px; }
.sm-no-val { color: #cfd8dc; }

.sm-qty-input { max-width: 100px; margin-left: auto; }
.sm-cell-sum { text-align: right; font-size: 12px; margin-top: 2px; }
.sm-sum-val { color: #00897b; font-weight: 600; }

.sm-row-active { background: #f1faf5; }
.sm-row-no-agr { background: #fef5f5; }

.sm-msg-ok td { background: #e8f5e9; color: #2e7d32; font-size: 12px; }
.sm-msg-err td { background: #ffebee; color: #c62828; font-size: 12px; }
.sm-msg-cell { padding: 5px 10px; }

.sm-foot-label {
  text-align: right;
  padding: 10px;
  font-weight: 700;
  background: #f0f6f2;
  color: #5a7d6a;
}
.sm-foot-sum {
  text-align: right;
  padding: 10px;
  font-weight: 700;
  color: #00897b;
  background: #f0f6f2;
}

/* ── Tabs ── */
.rs-tab-created-requests {
  display: none !important;
}
.rs-tabs-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e0ebe4;
}
.rs-tabs-wrap .rs-tabs {
  flex: 1 1 auto;
  min-width: 0;
  margin-bottom: 0;
  border-bottom: none;
}
.rs-tab-panels {
  background: transparent;
}

/* ── Requests tab ── */
.rs-req-header {
  gap: 10px;
}
.rs-req-dates {
  font-size: 12px;
  color: #78909c;
  font-weight: 500;
}
.rs-row--in-range {
  border-left: 3px solid #4caf50;
}
.rs-row--out-range {
  border-left: 3px solid #ff9800;
  background: #fff8e1;
  &:hover { background: #fff3cd; }
}
.rs-date-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}
.rs-contractor-cell {
  font-size: 12px;
  line-height: 1.5;
}
.rs-contractor-name {
  font-weight: 600;
  color: #37474f;
}
.rs-agreement-name {
  color: #78909c;
  font-size: 11px;
}
.rs-status-badge {
  font-size: 11px;
  padding: 2px 8px;
}

/* ── Transitions ── */
.rs-slide-enter-active,
.rs-slide-leave-active {
  transition: max-height 0.25s ease, opacity 0.2s ease;
  overflow: hidden;
}
.rs-slide-enter-from,
.rs-slide-leave-to { max-height: 0; opacity: 0; }
.rs-slide-enter-to,
.rs-slide-leave-from { max-height: 2000px; opacity: 1; }

.fade-enter-active,
.fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter-from,
.fade-leave-to { opacity: 0; }
</style>
